import * as tslib_1 from "tslib";
import { getCategoryNameFromId, getMasterCategoryList } from 'owa-categories';
import { createGroupMailTableQuery, getListViewTypeForGroup } from 'owa-group-mail-list-actions';
import { isFavoritingInProgress } from 'owa-mail-favorites-store';
import { getListViewTypeForFolder } from 'owa-mail-list-store';
import { lazyCreateFallbackPersonaSearchTableQuery, lazyCreateFallbackCategorySearchTableQuery, } from 'owa-mail-search-actions';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import { action } from 'satcheljs/lib/legacy';
import { createMailFolderTableQuery, createMailCategoryFolderTableQuery, } from 'owa-mail-list-actions';
/**
 * Called when a folder forest node is selected
 * @param node the folder forest node
 * @param actionSource action that initiated the switch folder action
 * @return a promise that resolves whether the select node has completed
 */
export default action('onFolderForestNodeSelected')(function onFolderForestNodeSelected(node, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var tableQuery, _a, categoryName, personaNode, pdlNode;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = node.type;
                    switch (_a) {
                        case 0 /* Folder */: return [3 /*break*/, 1];
                        case 4 /* Category */: return [3 /*break*/, 2];
                        case 1 /* Persona */: return [3 /*break*/, 6];
                        case 5 /* PrivateDistributionList */: return [3 /*break*/, 10];
                        case 2 /* Group */: return [3 /*break*/, 14];
                        case 6 /* PublicFolder */: return [3 /*break*/, 15];
                    }
                    return [3 /*break*/, 16];
                case 1:
                    tableQuery = createMailFolderTableQuery(node.id, getListViewTypeForFolder(node.id), 'mail');
                    return [3 /*break*/, 17];
                case 2:
                    if (!isFavoritingInProgress(node.id)) return [3 /*break*/, 4];
                    categoryName = getCategoryNameFromId(node.id, getMasterCategoryList());
                    return [4 /*yield*/, lazyCreateFallbackCategorySearchTableQuery.import()];
                case 3:
                    tableQuery = (_b.sent())(categoryName, getListViewTypeForFolder(node.id));
                    return [3 /*break*/, 5];
                case 4:
                    tableQuery = createMailCategoryFolderTableQuery(node.id);
                    _b.label = 5;
                case 5: return [3 /*break*/, 17];
                case 6:
                    personaNode = node;
                    if (!!personaNode.isSearchFolderPopulated) return [3 /*break*/, 8];
                    return [4 /*yield*/, lazyCreateFallbackPersonaSearchTableQuery.import()];
                case 7:
                    // Execute search while the folder is being populated
                    tableQuery = (_b.sent())(personaNode.displayName, personaNode.allEmailAddresses, getListViewTypeForFolder(node.id));
                    return [3 /*break*/, 9];
                case 8:
                    tableQuery = createMailFolderTableQuery(personaNode.searchFolderId, getListViewTypeForFolder(personaNode.searchFolderId), 'persona');
                    _b.label = 9;
                case 9: return [3 /*break*/, 17];
                case 10:
                    pdlNode = node;
                    if (!!pdlNode.data.isSearchFolderPopulated) return [3 /*break*/, 12];
                    return [4 /*yield*/, lazyCreateFallbackPersonaSearchTableQuery.import()];
                case 11:
                    // Execute search while the folder is being populated
                    tableQuery = (_b.sent())(pdlNode.data.displayName, pdlNode.data.members.map(function (member) { return member.emailAddress; }), getListViewTypeForFolder(node.id), true /* doNotShowPillSuggestions */);
                    return [3 /*break*/, 13];
                case 12:
                    tableQuery = createMailFolderTableQuery(pdlNode.data.searchFolderId, getListViewTypeForFolder(pdlNode.data.searchFolderId), 'persona');
                    _b.label = 13;
                case 13: return [3 /*break*/, 17];
                case 14:
                    tableQuery = createGroupMailTableQuery(node.id, getListViewTypeForGroup());
                    return [3 /*break*/, 17];
                case 15:
                    tableQuery = createMailFolderTableQuery(node.id, 1 /* Message */, 'mail');
                    return [3 /*break*/, 17];
                case 16: 
                // No-op for other node type
                return [3 /*break*/, 17];
                case 17: return [2 /*return*/, loadTableViewFromTableQuery(tableQuery, null /* loadTableViewDataPoint */, actionSource)];
            }
        });
    });
});
//# sourceMappingURL=onFolderForestNodeSelected.js.map